import { proxy } from 'valtio'
import { devtools, subscribeKey } from 'valtio/utils'
import { getConfig, CONFIGNAME, getPrompt, getTTSconfig } from '@/api/chat'
import { globalState } from './global'
import { StoreKey } from '@/constants'
import * as storage from '@/utils/storage'

const LIMIT_LENGTH = 2000
const configState = proxy({
  // 指令中心-多模态能力
  feature: [],
  // 指令中心-应用场景
  apps: [],
  // banner配置
  bannerData: {} as any,
  // 其他页面配置
  baseConfig: {} as any,
  showHistoryModal: false,
  showPromptModal: window.innerWidth > 1024,
  TTSConfig: {
    speaker_list: [],
    rate_config: {
      max: 500,
      min: -500,
      step: 100,
    },
  },
  timbreConfigShow: false,
  timbreConfig: {
    speaker: '',
    rate: 0,
  },
  hasShowGuideModal: false,
})

if (import.meta.env.DEV) {
  devtools(configState, { name: 'configState', enabled: true })
}

const configAction = {
  getDefaultTTS: async () => {
    try {
      const { data } = await getTTSconfig()
      if (!data) return
      configState.TTSConfig = data
      const cacheTimbreConfig = storage.getLocal(
        `${StoreKey.Timbre}_${globalState.userInfo.id}`,
      ) as {
        speaker: string
        rate: number
      }
      const hasCache =
        cacheTimbreConfig?.speaker &&
        data.speaker_list?.find(
          (item: any) => item.speaker === cacheTimbreConfig.speaker,
        )
      if (hasCache) {
        configState.timbreConfig = cacheTimbreConfig
      } else {
        const defaultItem = data.speaker_list?.find((item: any) => item.default)
        configAction.updateTimbreConfig({
          speaker: defaultItem?.speaker || '',
          rate: 0,
        })
      }
    } catch (error) {}
  },
  updateTimbreConfig: (payload: any) => {
    configState.timbreConfig = {
      ...configState.timbreConfig,
      ...payload,
    }
    if (globalState.userInfo?.id) {
      storage.setLocal(
        `${StoreKey.Timbre}_${globalState.userInfo.id}`,
        configState.timbreConfig,
        null,
      )
    }
  },
  getBaseConfig: async () => {
    try {
      const { data } = await getConfig(CONFIGNAME.STATUS)
      configState.baseConfig = data.config
      configState.baseConfig.limitLength =
        data.config.limitLength || LIMIT_LENGTH
    } catch (error) {
      configState.baseConfig = {
        accept: 'image/*',
        limitLength: 2000,
      }
    }
  },
  getPrompt: async () => {
    try {
      const { data } = await getPrompt()
      const {
        prompts: { feature, app },
      } = data
      configState.feature = feature?.list || []
      configState.apps = app?.list || []
    } catch (error) {
      console.log('getPrompt err ->', error)
    }
  },
  getBanner: async () => {
    try {
      const { data } = await getConfig(CONFIGNAME.BANNER)
      configState.bannerData = data?.config || {}
    } catch (error) {
      console.log('getPrompt err ->', error)
    }
  },
  changeHistoryModal: (statu: boolean) => {
    configState.showHistoryModal = statu
  },
  changePromptModal: (statu: boolean) => {
    configState.showPromptModal = statu
  },
}

export { configState, configAction }
